import React from 'react'
import propTypes from 'prop-types'
import moment from 'moment'
import Pen from './Pen'

import './Week.css'

class Week extends React.Component {
  weekDay = {}
  today = moment().format('YYYY-MM-DD')

  updateTimeSheet(e) {
    e.preventDefault()
    this.props.updateTimeSheet(e.target.id, this.weekDay[e.target.id].value)
  }

  render() {
    const { date, week, weekNumber, timeSheet } = this.props
    const findMatchingDay = (date, day, timeSheet) => {
      const year = date.format('YYYY')
      const month = date.format('MMMM')
      if(!timeSheet) timeSheet = {}
      if (!timeSheet[year]) timeSheet[year] = {}
      if (!timeSheet[year][month]) timeSheet[year][month] = {}

      const match = Object.keys(timeSheet[year][month]).find(key => {
        return key === day.date
      })

      return match ? timeSheet[year][month][match] : ''
    }
    return (
      <div className='week'>
        <h2>V{weekNumber}</h2>
        {week.map(day => {
          if(day.weekDay === 'Sun' || day.weekDay === 'Sat') return ''
          return (
            <div
              className={
                'week-day' 
                + (day.date === this.today ? ' is-today' : '')
              }
              key={day.date}
            >
              <div className='week-day--header'>
              {day.day}<br /> {day.weekDay.substr(0, 3)}
              </div>
              <input
                id={day.date}
                type='number'
                min='0'
                max='24'
                placeholder='0'
                value={findMatchingDay(date, day, timeSheet)}
                ref={input => (this.weekDay[day.date] = input)}
                onChange={e => this.updateTimeSheet(e)}
              />
            </div>
          )
        })}
        <div className='week-day'>
          <div className='week-day--header week-day--summary__hours'>
            <span >18 hrs</span>
          </div>
          <div className='week-day--summary'>
            <button className='week-day--summary__button'>
              <Pen />
            </button>
          </div>
        </div>
      </div>
    )
  }
}

Week.propTypes = {
  weekNumber: propTypes.string,
  date: propTypes.object,
  week: propTypes.array,
  timeSheet: propTypes.object,
  updateTimeSheet: propTypes.func
}

export default Week



// WEBPACK FOOTER //
// ./src/components/Week/Week.js